import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import SEO from '../components/SEO';
import { Button } from '../components/ui/button';
import { useWishlist } from '../contexts/WishlistContext';
import { repository } from '../lib/repository';

export default function Wishlist() {
  const { ids } = useWishlist();
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all(ids.map((s) => repository.getProduct(s))).then((res) => setItems(res.filter(Boolean)));
  }, [ids]);

  return (
    <div data-testid="page-wishlist" className="container py-16 md:py-24">
      <SEO title="Wishlist" description="Pieces you've noted for later." path="/wishlist" breadcrumb={[{ to: '/', label: 'Home' }, { label: 'Wishlist' }]} />
      <p className="overline text-muted-foreground">Kept</p>
      <h1 className="mt-3 font-display text-5xl md:text-7xl leading-[0.9]">Wishlist</h1>
      <p className="mt-4 text-muted-foreground max-w-lg">Pieces you've noted for later. Saved to this device.</p>

      {items.length === 0 ? (
        <div className="py-32 text-center">
          <p className="font-display text-3xl mb-6">Nothing kept yet.</p>
          <Button asChild data-testid="wishlist-empty-cta"><Link to="/shop">Start Browsing</Link></Button>
        </div>
      ) : (
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-12 md:gap-x-6" data-testid="wishlist-grid">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
